import { aws } from '../config';
import { ODD_STAGE_SHORT_LABEL, oddStageOf } from './oddStage';

// BSA API URLs
const BSA_DEV_URL = aws.devOddApiGateway.URL;
const BSA_DEV2_URL = aws.dev2OddApiGateway.URL;
const BSA_PROD_URL = aws.oddApiGateway.URL;

// Module-level Plan ODD stage, from the tenant's bsaProd setting.
let _planOddStage = null; // null = not fetched yet, which reads as prod

/**
 * Initialize Plan's ODD stage from the bsaProd tenant setting.
 * Must be called before any ODD API calls.
 * @param {*} bsaProdValue - the row's value: "prod", "dev", "dev2", a legacy boolean, or null when missing
 */
export const initPlanOddStage = bsaProdValue => {
  _planOddStage = oddStageOf(bsaProdValue);
};

/**
 * Reset the Plan ODD stage to not fetched (for testing).
 */
export const resetPlanOddStage = () => {
  _planOddStage = null;
};

/**
 * Check if the current environment is development
 * @returns {boolean}
 */
export const isDevelopmentEnvironment = () => {
  return process.env.NODE_ENV === 'development' || process.env.REACT_APP_BUILD_ENV === 'development';
};

/**
 * Get available BSA environments
 * @returns {Array} Array of environment options
 */
export const getPlanEnvironments = () => [
  { value: 'dev', label: 'Plan Dev', url: BSA_DEV_URL },
  { value: 'dev2', label: 'Plan Dev2', url: BSA_DEV2_URL },
  { value: 'prod', label: 'Plan Prod', url: BSA_PROD_URL }
];

/**
 * Get the current BSA environment
 * @returns {string} Current BSA environment ('prod', 'dev' or 'dev2')
 */
export const getCurrentPlanEnvironment = () => {
  // Always follow the bsaProd tenant setting (prod until it is known)
  return _planOddStage || 'prod';
};

/**
 * Get the current BSA API URL based on the selected environment
 * @returns {string} The BSA API URL
 */
export const getPlanApiUrl = () => {
  const environment = getCurrentPlanEnvironment();
  const environments = getPlanEnvironments();
  const selected = environments.find(env => env.value === environment);
  return selected ? selected.url : BSA_PROD_URL;
};

/**
 * Get the current BSA environment label for display
 * @returns {string} The display label for the current environment
 */
export const getCurrentPlanEnvironmentLabel = () => {
  // Display label for the header pill — just "Prod"/"Dev"/"Dev2" (no "Plan" prefix).
  return ODD_STAGE_SHORT_LABEL[getCurrentPlanEnvironment()];
};
